var render = function render(){var _vm=this,_c=_vm._self._c;return _c(!!_vm.url ? 'a' : 'div',{tag:"component",staticClass:"dui-notification",class:_vm.type,attrs:{"href":_vm.url}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }